import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    topupEligibleAlertTitle: {
        id: '_.outstanding_view.topupEligibleAlertTitle',
        defaultMessage: 'Great news, you can now request more funds -'
    },
    topupEligibleAlertSubtitle: {
        id: '_.outstanding_view.topupEligibleAlertSubtitle',
        defaultMessage:
            ' you can choose whether to go ahead once you have received an offer'
    },
    applyNowCTAText: {
        id: '_.outstanding_view.applyNowCTAText',
        defaultMessage: 'Apply Now'
    },
    notYetTopupEligilbeAlertText: {
        id: '_.outstanding_view.notYetTopupEligilbeAlertText',
        defaultMessage:
            "You can request more funds once you've repaid {amount} - "
    },
    notYetTopupEligilbeAlertDescription: {
        id: '_.outstanding_view.notYetTopupEligilbeAlertDescription',
        defaultMessage:
            "You've passed our eligibility checks but your approval will still be subject to a credit review"
    }
});
